import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import PlatformLayout from "@/layouts/PlatformLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Scale, Calculator, DollarSign, TrendingUp, Loader2 } from "lucide-react";
import { API } from "@/constants";

const PlatformSettlementsPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}/dashboard/overview`, { withCredentials: true });
        setData(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetchData();
  }, []);

  const ps = data?.stats?.practice_suite || {};

  return (
    <PlatformLayout activeTab="settlements">
      <div className="p-6 max-w-4xl mx-auto" data-testid="platform-settlements">
        <h1 className="text-xl font-bold text-slate-900 mb-6">Settlements & Negotiations</h1>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          {[
            { label: "Settlements", value: ps.settlements || 0, icon: Scale },
            { label: "Demand Letters", value: ps.demand_letters || 0, icon: DollarSign },
            { label: "Mediations", value: ps.mediations || 0, icon: TrendingUp },
            { label: "Motions", value: ps.motions || 0, icon: Calculator },
          ].map((s, i) => (
            <Card key={i}>
              <CardContent className="pt-4 pb-4 text-center">
                <s.icon className="h-5 w-5 text-blue-600 mx-auto mb-1" />
                <p className="text-2xl font-bold">{s.value}</p>
                <p className="text-xs text-slate-500">{s.label}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {[
            { to: "/tools/settlement-negotiation", label: "Settlement Strategy", desc: "AI-powered negotiation analysis with BATNA" },
            { to: "/tools/demand-letter", label: "Demand Letter Generator", desc: "Professional demand letters with damages breakdown" },
            { to: "/tools/mediation", label: "Mediation Brief", desc: "Position statements and concession framework" },
            { to: "/tools/motion", label: "Motion Practice", desc: "MSJ, motions to dismiss, compel, and more" },
            { to: "/tools/settlement", label: "Settlement Calculator", desc: "Calculate economic and non-economic damages" },
            { to: "/tools/insurance-report", label: "Insurance Report", desc: "Insurance analysis with bad faith indicators" },
          ].map((tool, i) => (
            <Link key={i} to={tool.to}>
              <Card className="hover:shadow-md transition-shadow cursor-pointer h-full">
                <CardContent className="pt-4 pb-4">
                  <p className="font-medium text-sm mb-1">{tool.label}</p>
                  <p className="text-xs text-slate-500">{tool.desc}</p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </PlatformLayout>
  );
};

export default PlatformSettlementsPage;
